// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"284f02ee","239":"cafd29b4","732":"5f85cc48"}[chunkId] + ".chunk.js";
};